export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    descripcion: item.descripcion || "Descripción no disponible",
    imagen: item.imagen || "Imagen no disponible",
  }));
